class BaseScreenController  {

    constructor(is_lms) {

        this.stackableOrder = 1;
        this.cssCreated;
        this.selectedTabId = null;
        this.currentActiveTab = null;
        var that = this;

        $(document).on("click", '#baseWorldIconLink', function() {
            api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
            $('#baseMenuDiv').hide();
            return false;
        });
        
        $(document).on("mouseover", '#playBtn,#challengeBtn', function() {
            $(this).children('img').css( 'opacity','.5' );
        });

        $(document).on("mouseout", '#playBtn,#challengeBtn', function() {
            $( this ).children('img').css( 'opacity','1' );
        });

        $(document).on("click", '.logoutBtn', function() {
            that.logout(null, true);
        });

        $(document).on("click", "#theMenu a", function() {
            $('#theMenu .menu-close').trigger('click');
        });

        $(document).on("click", '.challengeCloseBtn', function() {
            var action = $(this).attr('data-action');
            notificationSystem.canShowNotifications = true;
            $("#modalChallenge").modal('hide');
            
            // This is required to make it work 
            $("#modalContainer").modal('hide');
            window.location.reload();

            if(action != 'close'){
                api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
            }
            return false;
        });


        $(document).on("click", '.status-question-modal-close', function() {
            
            notificationSystem.canShowNotifications = true;
            //Buscar otra notificación
            notificationSystem.checkForNotifications();
            
            return false;
        });

        $(document).on("click", '#notificationCloseBtn', function() {
            $("#modalChallenge").modal('hide');
            notificationSystem.canShowNotifications = true;
            //Buscar otra notificación
            notificationSystem.checkForNotifications();
            return false;
        });

        $(document).on("click", '#notificationAcceptChallengeBtn', function() {
            var gameId = $(this).attr('data-gameid');
            var isChallengeNotification = $(this).attr('data-notification') == 'true';
            $("#modalChallenge").modal('hide');
            var category_id = worldHomeController.challenge.game.category_id;
            var challenge_user_id = worldHomeController.challenge.game.opponent.user_world_id;
            var bet_stars = worldHomeController.challenge.game.stars;

            if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_ACCEPT_CHALLENGE,'DIALOG');

            worldHomeController.setChallengeRequest(world.token,category_id,challenge_user_id,bet_stars);
            worldHomeController.createChallenge(worldHomeController.challenge.game.opponent,'CONFIRM_CHALLENGE',gameId,false,isChallengeNotification);
            return false;
        });

        $(document).on("click", '#cloneChallengeBtn', function() {
            var gameId = $(this).attr('data-gameid');
            var dataUserName = $(this).attr('data-username');

            swal({
                    title: "",
                    text: sprintf(Translator.trans('TR_DESEA_PEDIR_REVANCHA_AL_USUARIO_PLACEHOLDER'),dataUserName),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "",
                    closeOnConfirm: true
                },
                function(){
                    $("#modalChallenge").modal('hide');
                    
                    api.getChallengeInfo(world.token,gameId,'REVENGE_CHALLENGE',true);
                });

            return false;
        });

        //Imagenes de retar de la pantalla de amigos
        $(document).on("click", '#baseUserIcon', function(e) {
            if($(document).find('.profileScreen').length === 0) {
                if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_ACCESS, 'MENU');
                api.getUserProfile(world.token, user.user_world_id);
            }
            e.stopPropagation();
        });

        $(document).on("click", '#playerImg', function(e) {
            baseController.selectedTabId = null;
        });

        $(document).on("show.bs.modal", '#modalHelpLinksImages', function() {
            $('.modal-body-scrollable').css('max-height',$( window ).height()*0.8);
            $('.modal-body-scrollable').css('overflow-y','auto');
        });

        $(document).on('click', '#menuToggle', function () {
            createNiceScroll($('.menu-wrap'));
        });

        $(document).on("click", '#open-notifications-button', function(e) {

            api.getNotifications(null, null, null, function(response) {

                if (api.checkisValidResult(response)) {

                    const context = {
                        iconName: "icoNotification",
                        title: Translator.trans("TR_NOTIFICACIONES"),
                        subtitle: sprintf(response.result.total_unread === 1 ? Translator.trans("TR_1_NUEVA") : Translator.trans("TR_X_NUEVAS"), response.result.total_unread),
                        listType: "notifications",
                        notifications: response.result.notifications,
                        totalUnread: response.result.total_unread
                    }

                    dataListNotificationsController.initialize(context);

                }

            });

        });

    };

    openNotificationOnDrawer({openInDrawer = false, callback = null}) {
        api.getNotifications(null, null, null, (response) => {
            if (api.checkisValidResult(response)) {
                const context = {
                    iconName: "icoNotification",
                    title: Translator.trans("TR_NOTIFICACIONES"),
                    subtitle: sprintf(response.result.total_unread === 1 ? Translator.trans("TR_1_NUEVA") : Translator.trans("TR_X_NUEVAS"), response.result.total_unread),
                    listType: "notifications",
                    notifications: response.result.notifications,
                    totalUnread: response.result.total_unread
                }

                dataListNotificationsController.initialize(context, openInDrawer);

                if(callback) {
                    callback();
                }
            }
        });
    };

    drawMainMenu(option, tab_id = null){
        let that = this;

        if(chatScreenController && chatScreenController.inChatRoom){

            chatScreenController.inChatRoom = false;
            chatScreenController.roomSelectedOption = null;

            if (chatScreenController.room.id) {
                socketRequest.changeRoomStatus(chatScreenController.inChatRoom, chatScreenController.room.id);
            }

        }

        var num_elements = 0;

        if(typeof(world?.world_tabs) !== 'undefined') {
            $.each(world.world_tabs, function (index, world_tab) {
                if (world_tab && world_tab.visible) {
                    num_elements++;
                }
            });
        }

        var template = Handlebars.compile($("#worldMenuScreen").html());
        var context = {world:world, selected_tab:option, num_elements:num_elements, tab_id: tab_id};
        $("#baseMenuDiv").html(template(context));

        this.scrollTabs();

        $(".selected-tab").off().on("click", function (e) {
            e.preventDefault();
            let tab_id = $(this).attr('id');
            let folderId = $(this).data('folder-id');
            that.selectedTabAction(tab_id, folderId);
        });

        if (tab_id) {
            this.currentActiveTab = this.getTabByWorldTab(tab_id);
        }

        chatScreenController.drawChatUnreadMessages();
        challengeListScreenController.drawPendingChallenges();

    }

    legalAdvice() {
        api.getLegalInfo((response) => {
            if (response.success) {
                let template = Handlebars.compile($("#legalInfoModal").html());
                $("#modalContainer").html(template(response?.result?.legal_info)).modal('show');

                $(document).one('click', '.modal-close-btn, .modal-accept-btn', function () {
                    $("#modalContainer").modal('hide').empty();
                    $(document).off('click', '.modal-close-btn, .modal-accept-btn');
                });
            }
        });
    }

    logout(redirectToken = null, exitWorld = false) {
        // console.log("🚀 ~ BaseScreenController ~ logout ~ redirectToken:", redirectToken);
        // console.log("🚀 ~ BaseScreenController ~ logout ~ exitWorld:", exitWorld);

        removeUserAccessStorage();

        // Eliminar la lista de eventos de seguimiento y completitud almacenada en localstorage
        storage.removeItem('se');

        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_LOGOUT,'');

        try { if (typeof kc_performKeycloakLogout === 'function') kc_performKeycloakLogout(); } catch (e) {}

        api.getWorldAuthProtocols(world.token, function (authProtocol, worldToken) {
            // console.log("🚀 ~ BaseScreenController ~ logout ~ authProtocol:", authProtocol)
            if (authProtocol) {
                // Trigger Keycloak logout if available
                try { if (typeof kc_performKeycloakLogout === 'function') kc_performKeycloakLogout(); } catch (e) {}
                // This is not necessary because this urls does nothing on backend
                // location.href = Routing.generate('front_third_party_logout', {world_token: worldToken});
                location.href = '/'
                // TODO desloguear también del world, sino se queda en bucle
            } else {
                if(typeof redirectToken === 'string') {
                    api.getWorldTheme(redirectToken, false, function () {
                        return loginController.goToResourceAfterLoginOrRegister(qsResource, qsSubType, qsWorldToken)
                    });
                } else if (exitWorld) {
                    // If no third-party protocol, still try to logout from Keycloak if present
                    try { if (typeof kc_performKeycloakLogout === 'function') kc_performKeycloakLogout(); } catch (e) {}
                    location.href = Routing.generate('front_office_homepage');
                }
            }
        });
    }

    selectedTabAction(worldTabId, folderId = null) {
        let that = this;
        let selectedTab = this.getTabByWorldTab(worldTabId);
        that.currentActiveTab = selectedTab;
        if (selectedTab) {
            let modalTitle = !selectedTab.visible ? selectedTab.name : null;
            that.selectedTabId = selectedTab.id;
            that.tabAction(selectedTab.id, modalTitle, folderId, worldTabId);
        } else {
            swal({
                title: '',
                text: Translator.trans('TR_SECCION_NO_DISPONIBLE'),
                type: "warning",
                confirmButtonText: Translator.trans('TR_ACEPTAR'),
                closeOnConfirm: true
            });
        }
    }

    tabAction(tabId, modalTitle = null, folderId = null, worldTabId = null) {
        let that = this;
        that.showSlogan(tabId, worldTabId);

        switch (tabId) {
            case 1:     // playTab
                if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_MENU_ACCESS, analytics.GA_CATEGORY_MENU_ACCESS_EVENT_GENERAL, '');
                that.resetStackableOrder();
                let template = Handlebars.compile($("#baseScreen").html());
                api.loadPlayTab(worldHomeController, template, baseController);
                break;
            case 2:     // challengesTab
                that.loadRetosTab();
                break;
            case 3:     // rankingTab
                that.loadRankingTab();
                break;
            case 4:     // friendsTab
                that.loadFriendsTab();
                break;
            case 5:     // quizTab
                that.loadQuizfitTab();
                break;
            case 6:     // documantationTab
                that.loadDocumentationTab(folderId, worldTabId);
                break;
            case 7:     // levelsTab
                api.getWorldLevels(world.token);
                break;
            case 8:     // logrosTab
                api.getWorldAchievments(world.token);
                break;
            case 9:     // HelpTab
                $('#modalShowHelpLinksImages').modal('hide');
                api.getWorldHelpImages(world.token);
                break;
            case 10:    // misQuizfitsTab
                changeQuizController.draw();
                break;
            case 11:    // legalAdvice
                that.legalAdvice();
                break;
            case 12:    // suportTab
                if(world.support_email) {
                    window.location.href = "mailto:" + world.support_email;

                    if($('.menu-close').length > 0) {
                        $('.menu-close').trigger('click');
                    }
                }
                break;
            case 13:    // appPlayTab
                $('#modalShowToken').modal('show');
                break;
            case 17:    // logOutTab
                that.logout();
                break;
            case 18:    // dataProtectionTab
                api.getUserPolicies();
                break;
            case 19:    // chatTab
                that.loadChatTab();
                break;
            case 20:
                that.loadMyContentsTab();
                break;

            case 21:
            case 22:
                that.loadExternalTab(worldTabId);
                break;
        }
    }

    // Mostrar / ocultar el eslogan
    showSlogan(tabId=null, worldTab=null){
        console.warn('deprecated function... please remove in future features...');
    }

    scrollTabs(numTabs = 6) {
        let totalTabsWidth = 0;

        document.querySelectorAll('.nav-tabs li').forEach((tab, index) => {
            totalTabsWidth += (tab?.clientWidth || 0);
        });

        if (totalTabsWidth > 680) {
            //little hack to prevent the overflow
            $('.nav-tabs').append('<li style="padding: 0 50px"></li>');

            $('.nav-tabs li a').css('padding-left', '4px');
            $('.nav-tabs li a').css('padding-right', '4px');
            $('.nav-tabs li a').css('margin-left', '8px');
            $('.nav-tabs li a').css('margin-right', '8px');

            $('.nav-tabs').scrollingTabs({
                enableSwiping: true,
                leftArrowContent: [
                    '<span class="world_text_color" style="display: inherit"><svg id="ico-ux-chevron-left-24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">',
                        '<path id="Trazado_7684" data-name="Trazado 7684" d="M0,0H24V24H0Z" fill="rgba(0,0,0,0)"/>',
                        '<path id="Trazado_7685" data-name="Trazado 7685" d="M15,6,9,12l6,6" fill="rgba(0,0,0,0)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>',
                    '</svg></span>'
                ].join(''),
                rightArrowContent: [
                    '<span class="world_text_color" style="display: inherit">',
                    '<svg id="ico-ux-chevron-right-24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">',
                        '<g id="ico-card-mgr-section-open" transform="translate(0 24) rotate(-90)">',
                        '<g id="chevron-down" transform="translate(24 24) rotate(180)">',
                        '<path id="Trazado_6465" data-name="Trazado 6465" d="M0,24H24V0H0Z" transform="translate(0)" fill="rgba(0,0,0,0)"/>',
                        '<path id="Trazado_6466" data-name="Trazado 6466" d="M0,6,6,0l6,6" transform="translate(6 9)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>',
                        '</g></g></svg></span>',
                ].join('')
            }).on('ready.scrtabs', function () {
                $('.scrtabs-tab-container').css('height', '25px');
                $('.scrtabs-tabs-fixed-container').css('height', '25px');
                $('.scrtabs-tab-scroll-arrow').css({
                    'height': '25px',
                    'border': 'none',
                    'padding-top': '7px',
                    'color': '#ffffff'
                });
            });
        }
    }

    loadExternalTabService(worldTabId, onSuccess = null, onError = null) {
        const tab = (world.world_tabs || []).find(w => Number(w.world_tab_id) === Number(worldTabId));

        $.ajax({
            type: "GET",
            url: tab.external_url,
            data: {
                webversion: 1,
            },
            beforeSend: function (jqXHR, settings) {
                settings.data = api.addAccessToken(settings);
                api.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (onSuccess) {
                    onSuccess(response);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('error', jqXHR, textStatus, errorThrown);

                if (onError) {
                    onError(textStatus);
                }
            }
        });
    }

    loadExternalTab(worldTabId) {
        const template = Handlebars.compile($("#worldGeneralExternalScreen").html());
        const tab = (world.world_tabs || []).find(w => Number(w.world_tab_id) === Number(worldTabId));

        if(!tab?.external_url) {
            if (window.Sentry) {
                Sentry?.captureMessage('No external url found for tab', tab, worldTabId);
            }

            baseController.stackView(tab, template, {externalUrl: '#'});
            return;
        }

        const tabId = tab.id;

        $.ajax({
            type: "GET",
            url: tab.external_url,
            data: {
                webversion: 1,
            },
            beforeSend: function (jqXHR, settings) {
                settings.data = api.addAccessToken(settings);
                api.sendHeader(jqXHR, true);
            },
            success: function (response) {
                const externalUrl = response.external;

                baseController.stackView(tabId, template, {externalUrl});
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('error', jqXHR, textStatus, errorThrown);

                baseController.stackView(tabId, template, {externalUrl: '#'});
            }
        });
    }

    loadGameTab(callback = null) {
        this.resetStackableOrder();
        let template = Handlebars.compile($("#baseScreen").html());

        api.loadPlayTab(worldHomeController, template, baseController, callback);
    }

    loadRetosTab(){
        let tabs = new Tabs();
        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_MENU_ACCESS, analytics.GA_CATEGORY_MENU_ACCESS_EVENT_INFO_CHALLENGES,'');
        this.resetStackableOrder();
        api.getPendingChallenges(world.token);
        this.drawMainMenu(tabs.RETOS_TAB);
    }

    loadRankingTab(callback = null){
        let tabs = new Tabs();
        // if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_MENU_ACCESS, analytics.GA_CATEGORY_MENU_ACCESS_EVENT_RANKING,'');
        this.resetStackableOrder();

        window.runCallback = callback;
        api.getGeneralRanking(world.token);
        this.drawMainMenu(tabs.RANKING_TAB);
    }

    loadFriendsTab(){
        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_MENU_ACCESS, analytics.GA_CATEGORY_MENU_ACCESS_EVENT_FRIENDS,'');
        this.resetStackableOrder();
        api.getFriends(world.token,false,null);
    }

    loadQuizfitTab(){
        api.getQuestionStats(world.token,true);
    }

    loadDocumentationTab(folderId, tabId){
        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_MENU_ACCESS, analytics.GA_CATEGORY_MENU_ACCESS_EVENT_DOCUMENTATION,'');
        let tab = this.getTabByWorldTab(tabId);

        api.getFolderDocuments(folderId, 0, documentationScreenController.documentationPageSize, function(response) {
            documentationScreenController.setDocumentation(response.result);
            documentationScreenController.openDocumentation(response.result, folderId, tabId, !tab.visible);  // Indicar a partir de que carpeta mostrar (forlder-tab-id)
        });
    }

    loadChatTab(callback = null){
        // if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_MENU_ACCESS, analytics.GA_CATEGORY_MENU_ACCESS_EVENT_CHAT,'');
        api.getChats( (roomsResponse) => {
            api.getUnreadMessages(roomsResponse.rooms);
            chatScreenController.drawChatUnreadMessages();
            chatScreenController.saveRooms(roomsResponse.rooms, true);
            let supportRooms = chatScreenController.supportRooms.rooms;
            let otherRooms = chatScreenController.individualRooms.rooms.concat(chatScreenController.groupRooms.rooms, chatScreenController.canalRooms.rooms);
            let roomsToShow = chatScreenController.assistantView ? supportRooms : otherRooms;
            chatScreenController.drawChatList(roomsToShow, false);

            if(callback) {
                callback();
            }
        });
    }

    loadMyContentsTab() {
        const documentationNew = documentationScreenController.documentationNew;
        documentationNew.myContents.initialize();
    }

    /**
     * Hide headers
     * similar to $("#baseMenuDiv").hide()
     **/
    hideSingleMenu(template = null, context = null) {
        //remove old nav-menu
        if(document.querySelector(".body__container__content nav")) {
            document.querySelector(".body__container__content nav").remove();
        }

        if($(window).width() >= 1280) {
            const el = $(".body__container__content");

            if(el.find('.singlemenu')) {
                el.find('.singlemenu').hide();

                if(template) {
                    //add menu nav-arrow
                    el.prepend(template(context));
                }
            }
        } else {
            $("body").find('.singlemenu').hide();

            if(template) {
                $("#baseMenuDiv").append(template(context));
            }
        }
    }

    setSimpleContent(template,context){
        $("#jugar").html(template(context));
    }

    /**
     *
     * @param template
     * @param context
     * @param agent {null|PROFILE|GAME|CHAT|CONTENT}
     */
    stackSimpleContent(template, context, agent = null) {
        // console.trace('stackSimpleContent: ', {template, context, world});

        const addToStack = () => {
            if (finderController.documentOpen) {

                $("#finder-wrapper").find('.stackable').hide();
                $("#finder-wrapper").append(template(context));
            } else {
                $("#jugar").find('.stackable').hide();
                $("#jugar").append(template(context));
            }

            documentationScreenController.getScreen();
        }

        const legacyStack = document.querySelector("#legacyStack");

        if (legacyStack && world?.mode === "newLayout") {
            if (context?.document?.id) {
                // Al salir del test se dibuja el path desde dos sitios (cierre del test y goToMainApp):
                // sin esto quedan dos capas PATH apiladas y la superior tapa el botón de cerrar.
                if (context.document.type === "PATH") {
                    // Tampoco debe quedar bajo el path la capa de un test ya cerrado/finalizado.
                    $("#legacyStack section").has(".doc-details-PATH, .doc-details-TEST").remove();
                }

                $("#legacyStack").append(template(context));
                documentationScreenController.documentationSockets.startNodeConnection();
            }

            if (context?.addToStack) {
                addToStack();
            }

            // Prevent execution of legacy view
            if(window.LEGACY_SUPPORT_STACK_ENABLED && ['PROFILE', 'GAME', 'CHAT', 'CONTENT', 'CHALLENGE'].includes(agent)) {
                addToStack();
            }
        } else {
            addToStack();
        }
    }

    /**
     *
     * @param template
     * @param context
     */
    stackGameInModuleApp(template, context) {
        // console.trace('stackGameInModuleApp: ', {template, context, world});

        const addToStack = () => {
            if (finderController.documentOpen) {
                $("#finder-wrapper").find('.stackable').hide();
                $("#finder-wrapper").append(template(context));
            } else {
                $("#legacyStack").find('.stackable').hide();
                $("#legacyStack").append(template(context));
            }

            documentationScreenController.getScreen();
        }

        addToStack();
    }

    stackSimpleMenu(context, template){
        this.stackableOrder++ ;

        if (!template) {
            template = Handlebars.compile($("#singleMenuScreen").html());
        }

        this.hideSingleMenu(template, context);

    }

    stackFullScreenMenu(tabName) {
        let menuTemplate = Handlebars.compile($("#fullModalMenu").html());
        this.stackSimpleMenu({title: tabName, icon: 'close'}, menuTemplate);
    }

    stackView(tab, template, context = {}) {
        const isModuleApp = window.reactZustandBridge && world?.mode === 'newLayout';
        if (!tab?.visible && !isModuleApp) { // Mostrar como full modal
            this.hideSingleMenu();

            baseController.stackFullScreenMenu(tab?.name);
            baseController.stackSimpleContent(template, context);
        } else {
            $("#jugar").html(template(context));
        }
    }

    closeSimpleMenu() {
        if($(window).width() >= 1280) {
            $('.body__container .singlemenu').first().remove();
            $('.body__container .singlemenu').first().show();
        } else {
            $('.singlemenu').last().remove();
            $('.singlemenu').last().show();
        }

        this.closeStack();
    }

    closeStack() {
        if($('#baseMenuDiv').find('.singlemenu').length == 0){
            $('#baseMenuDiv').show();
        }

        $('.stackable').last().remove();
        $('.stackable').last().show();
        $('.nav-tabs').scrollingTabs('refresh');
        documentationScreenController.getScreen();
    }

    resetStackableOrder(){
        this.stackableOrder = 1;
        this.hideSingleMenu();
    }

    draw(theme) {
        if(!this.cssCreated){
            var sheet = (function () {
                var style = document.createElement("style");
                style.appendChild(document.createTextNode(""));
                document.head.appendChild(style);
                return style.sheet;
            })();

            // Headers colors
            sheet.insertRule('.world_nav_color { color: #' + theme.header_text_color + ' !important; }', 0);
            sheet.insertRule('.world_nav_bg { background-color: #' + theme.header_background_color + ' !important; }', 0);

            // Text colors
            sheet.insertRule('.world_color_1 { color: #' + theme.color_1 + ' !important; }', 0);
            sheet.insertRule('.world_color_2 { color: #' + theme.color_2 + ' !important; }', 0);
            sheet.insertRule('.world_color_3 { color: #' + theme.color_3 + ' !important; }', 0);
            sheet.insertRule('.world_color_4 { color: #' + theme.color_4 + ' !important; }', 0);
            sheet.insertRule('.world_color_5 { color: #' + theme.color_5 + ' !important; }', 0);
            sheet.insertRule('.world_text_color { color: #' + theme.login_text_color + ' !important; }', 0);
            sheet.insertRule('.world_title_desc_color { color: #' + theme.color_title + ' !important; }', 0);

            // Background colors
            sheet.insertRule('.world_color_1_bg { background-color: #' + theme.color_1 + ' !important; }', 0);
            sheet.insertRule('.world_color_2_bg { background-color: #' + theme.color_2 + ' !important; }', 0);
            sheet.insertRule('.world_color_3_bg { background-color: #' + theme.color_3 + ' !important; }', 0);
            sheet.insertRule('.world_color_4_bg { background-color: #' + theme.color_4 + ' !important; }', 0);
            sheet.insertRule('.world_color_5_bg { background-color: #' + theme.color_5 + ' !important; }', 0);
            sheet.insertRule('.world_text_color_bg { background-color: #' + theme.login_text_color + ' !important; }', 0);

            // Border colors
            sheet.insertRule('.world_color_1_bc { border-color: #' + theme.color_1 + ' !important; }', 0);
            sheet.insertRule('.world_color_2_bc { border-color: #' + theme.color_2 + ' !important; }', 0);
            sheet.insertRule('.world_color_3_bc { border-color: #' + theme.color_3 + ' !important; }', 0);
            sheet.insertRule('.world_color_4_bc { border-color: #' + theme.color_4 + ' !important; }', 0);
            sheet.insertRule('.world_color_5_bc { border-color: #' + theme.color_5 + ' !important; }', 0);
            sheet.insertRule('.world_text_color_bc { border-color: #' + theme.login_text_color + ' !important; }', 0);
            
            // Stroke colors
            sheet.insertRule('.world_color_1_sc { stroke: #' + theme.color_1 + ' !important; }', 0);
            
            // Placeholder colors Chrome 57+, Firefox 51+, Opera 43+
            if ((bowser.chrome && bowser.compareVersions([bowser.version, '57']) >= 0) ||
                (bowser.firefox && bowser.compareVersions([bowser.version, '51']) >= 0) ||

                (bowser.opera && bowser.compareVersions([bowser.version, '43']) >= 0)) {
                sheet.insertRule('.world_color_1_placeholder::placeholder { color: #' + theme.color_1 + ' !important; }', 0);
                sheet.insertRule('.world_color_2_placeholder::placeholder { color: #' + theme.color_2 + ' !important; }', 0);
                sheet.insertRule('.world_color_3_placeholder::placeholder { color: #' + theme.color_3 + ' !important; }', 0);
                sheet.insertRule('.world_color_4_placeholder::placeholder { color: #' + theme.color_4 + ' !important; }', 0);
                sheet.insertRule('.world_color_5_placeholder::placeholder { color: #' + theme.color_5 + ' !important; }', 0);
                sheet.insertRule('.world_text_color_placeholder::placeholder { color: #' + theme.login_text_color + ' !important; }', 0);
            }
            // Placeholder colors Chrome < 57, Safari 5+, Opera 15+
            else if (bowser.chrome ||
                (bowser.safari) ||
                (bowser.opera   && bowser.compareVersions([bowser.version, '15']) >= 0)) {
                sheet.insertRule('.world_color_1_placeholder::-webkit-input-placeholder { color: #' + theme.color_1 + ' !important; }', 0);
                sheet.insertRule('.world_color_2_placeholder::-webkit-input-placeholder { color: #' + theme.color_2 + ' !important; }', 0);
                sheet.insertRule('.world_color_3_placeholder::-webkit-input-placeholder { color: #' + theme.color_3 + ' !important; }', 0);
                sheet.insertRule('.world_color_4_placeholder::-webkit-input-placeholder { color: #' + theme.color_4 + ' !important; }', 0);
                sheet.insertRule('.world_color_5_placeholder::-webkit-input-placeholder { color: #' + theme.color_5 + ' !important; }', 0);
                sheet.insertRule('.world_text_color_placeholder::-webkit-input-placeholder { color: #' + theme.login_text_color + ' !important; }', 0);
            }
            // Placeholder colors Firefox < 51
            else if (bowser.firefox) {
                // Placeholder colors Firefox 19+
                if (bowser.compareVersions([bowser.version, '19']) >= 0) {
                    sheet.insertRule('.world_color_1_placeholder::-moz-placeholder { color: #' + theme.color_1 + ' !important; }', 0);
                    sheet.insertRule('.world_color_2_placeholder::-moz-placeholder { color: #' + theme.color_2 + ' !important; }', 0);
                    sheet.insertRule('.world_color_3_placeholder::-moz-placeholder { color: #' + theme.color_3 + ' !important; }', 0);
                    sheet.insertRule('.world_color_4_placeholder::-moz-placeholder { color: #' + theme.color_4 + ' !important; }', 0);
                    sheet.insertRule('.world_color_5_placeholder::-moz-placeholder { color: #' + theme.color_5 + ' !important; }', 0);
                    sheet.insertRule('.world_text_color_placeholder::-moz-placeholder { color: #' + theme.login_text_color + ' !important; }', 0);
                } else { // Placeholder colors Firefox < 19
                    sheet.insertRule('.world_color_1_placeholder:-moz-placeholder { color: #' + theme.color_1 + ' !important; }', 0);
                    sheet.insertRule('.world_color_2_placeholder:-moz-placeholder { color: #' + theme.color_2 + ' !important; }', 0);
                    sheet.insertRule('.world_color_3_placeholder:-moz-placeholder { color: #' + theme.color_3 + ' !important; }', 0);
                    sheet.insertRule('.world_color_4_placeholder:-moz-placeholder { color: #' + theme.color_4 + ' !important; }', 0);
                    sheet.insertRule('.world_color_5_placeholder:-moz-placeholder { color: #' + theme.color_5 + ' !important; }', 0);
                    sheet.insertRule('.world_text_color_placeholder:-moz-placeholder { color: #' + theme.login_text_color + ' !important; }', 0);
                }
            }
            // Placeholder colors IE 10+ y Edge
            else if ((bowser.msie && bowser.compareVersions([bowser.version, '10']) >= 0)) {
                sheet.insertRule('.world_color_1_placeholder:-ms-input-placeholder { color: #' + theme.color_1 + ' !important; }', 0);
                sheet.insertRule('.world_color_2_placeholder:-ms-input-placeholder { color: #' + theme.color_2 + ' !important; }', 0);
                sheet.insertRule('.world_color_3_placeholder:-ms-input-placeholder { color: #' + theme.color_3 + ' !important; }', 0);
                sheet.insertRule('.world_color_4_placeholder:-ms-input-placeholder { color: #' + theme.color_4 + ' !important; }', 0);
                sheet.insertRule('.world_color_5_placeholder:-ms-input-placeholder { color: #' + theme.color_5 + ' !important; }', 0);
                sheet.insertRule('.world_text_color_placeholder:-ms-input-placeholder { color: #' + theme.login_text_color + ' !important; }', 0);
            }

            // Old colors
            sheet.insertRule('.world_base_color { color:#' +  theme.base_color +' !important; }', 0);
            sheet.insertRule('.world_base_color_bg { background-color:#' +  theme.base_color +' !important; }', 0);
            sheet.insertRule('.world_base_dark_dark_color_bg { background-color:#' +  theme.base_dark_dark_color +' !important; }', 0);
            sheet.insertRule('.world_base_dark_color_bg { background-color:#' +  theme.base_dark_color +' !important; }', 0);
            sheet.insertRule('.uil-rolling-css > div div {border-color:#'+theme.base_color+'}', 0);

        }
       
        if(theme.screen_home_background_image){
            $.backstretch(theme.screen_home_background_image, {speed: 50});
        }

        this.cssCreated = true;
        if (typeof ga === 'function') ga('send', 'pageview', analytics.GA_SCREEN_MENU);
    };

    getTabByWorldTab(worldTabId){
        try {
            let selectedTab = _.filter(world?.world_tabs, function (tab) { return worldTabId == tab.world_tab_id});
            return selectedTab.length > 0 ? selectedTab[0] : null;
        } catch (e) {
            return null;
        }
    }

    getTabById(tabId){
        try {
            let selectedTab = _.filter(world?.world_tabs, function (tab) { return tabId == tab.id});
            return selectedTab.length > 0 ? selectedTab[0] : null;
        } catch (e) {
            return null;
        }
    }

    userCustomization() {

        const userCustomization = {};

        _.keys(world.user_directory_configuration).map(function(key) {

            let userDirectoryParameter = world.user_directory_configuration[key];
            let userPrivacyParameter = world.user_privacy_configuration[key];

            if (userDirectoryParameter === undefined || userDirectoryParameter === null) {
                userDirectoryParameter = true;
            }

            if (userPrivacyParameter === undefined || userPrivacyParameter === null) {
                userPrivacyParameter = true;
            }

            userCustomization[key] = userDirectoryParameter && userPrivacyParameter;
            userCustomization.show_opponent_profile = world?.profile_customization?.show_opponent_profile;

        });

        userCustomization.visible_categories = _.filter(world.user_privacy_configuration.visible_categories, function (cat1) {
            return _.filter(world.user_directory_configuration.visible_category_filters, ['id', cat1.id]).length > 0;
        })

        return userCustomization;
    }
}